import {AsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";

interface AddNewSimplePlanningDataCommon {
    show: boolean
    type: "group" | "resource",
    id: string,
}

type GenericAsyncThunk = AsyncThunk<unknown, unknown, any>
type RejectedAction = ReturnType<GenericAsyncThunk["rejected"]>
type FullfilledAction = ReturnType<GenericAsyncThunk["fulfilled"]>

export interface IAppState {
    currentPage: string | null,
    tenantAccessDenied: boolean,
    notificationAlertMessage: string | undefined,
    isAddingCRForGroup: string | undefined,
    drawerSize: number,
    messageErrors: string[],
    lastActionResult: boolean | undefined
    headerHeight: number,
    userRole: string | undefined,
    userRoleLoading: boolean,
    activeRequestsCount: number,
}
 
const initialState: IAppState = {
    currentPage: "",
    tenantAccessDenied: false,
    notificationAlertMessage: undefined,
    isAddingCRForGroup: undefined,
    drawerSize: 0,
    messageErrors: [],
    lastActionResult: undefined,
    headerHeight: 0,
    userRole: undefined,
    userRoleLoading: false,
    activeRequestsCount: 0,
};

export const appStateSlice = createSlice({
    name: "appState",
    initialState,
    reducers: {
        setHeaderHeight: (state, action: PayloadAction<number>) => {
            state.headerHeight = action.payload;
        },
        setLastActionResult: (state, action: PayloadAction<boolean | undefined>) => {
            state.lastActionResult = action.payload;
        },
        setMessageErrors: (state, action: PayloadAction<string[]>) => {
            state.messageErrors = action.payload;
        },
        setCurrentPage: (state, action: PayloadAction<string>) => {
            state.currentPage = action.payload
        },
        setTenantAccessDenied: (state, action: PayloadAction<boolean>) => {
            state.tenantAccessDenied = action.payload;
        },
        setNotificationAlertMessage: (state, action: PayloadAction<string | undefined>) => {
            state.notificationAlertMessage = action.payload;
        },
        setUserRole: (state, action: PayloadAction<string | undefined>) => {
            state.userRole = action.payload;
        },
        setUserRoleLoading: (state, action: PayloadAction<boolean>) => {
            state.userRoleLoading = action.payload;
        },
        startRequest: (state) => {
            state.activeRequestsCount += 1;
        },
        finishRequest: (state) => {
            state.activeRequestsCount = Math.max(0, state.activeRequestsCount - 1);
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher<RejectedAction>(
                (action) => action.type.endsWith('/rejected'),
                (state) => {
                    state.lastActionResult = false;

                }
            )
            .addMatcher<FullfilledAction>(
                (action) => action.type.endsWith('_n/fulfilled'),
                (state) => {
                    state.lastActionResult = true;
                }
            )
    }
})


export const {
    setCurrentPage,
    setTenantAccessDenied,
    setNotificationAlertMessage,
    setMessageErrors,
    setLastActionResult,
    setHeaderHeight,
    setUserRole,
    setUserRoleLoading,
    startRequest,
    finishRequest,
} = appStateSlice.actions;
export default appStateSlice.reducer
